var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",staticStyle:{"max-width":"1160px"}},[_c('div',[_vm._t("body")],2),(_vm.showDivider)?_c('v-divider'):_vm._e(),_c('div',{staticClass:"mt-5 d-flex justify-space-between"},[_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }